import stylex from '@stylexjs/stylex';
import { FC, useState } from 'react';
import { styles } from './styles';

import { IOrgnizerProps } from '../model/types';
import { Button, Checkbox } from '@shared/ui/kit';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const Organizer: FC<IOrgnizerProps> = ({ organizer, actions, onGetCode, isChecked, handleCheckboxChange }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      {...stylex.props(styles.container)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div {...stylex.props(styles.body)}>
        <Checkbox isChecked={isChecked} onChange={() => handleCheckboxChange()} />
        <p {...stylex.props(styles.title)}>
          {organizer.lastName} {organizer.firstName}
        </p>
      </div>
      <div {...stylex.props(styles.row)}></div>
      <div {...stylex.props(styles.rightRow)}>
        {isHovered && (
          <Button
            variant="primary"
            size="small"
            settings={{
              height: '24px',
              padding: '4px 12px',
              fontSize: typography['fontSizeCaption-2'],
              lineHeight: typography['lineHeightCaption-2'],
              borderRadius: anatomy.borderRadiusXs,
            }}
            onClick={() => onGetCode(organizer)}
          >
            <span>Получить код</span>
          </Button>
        )}
        {actions}
      </div>
    </div>
  );
};
